/* eslint-disable indent */
import React, { Fragment } from 'react';
import { IRestaurant, TTableId } from 'features/home/types/homeTypes';
import {
  isDelivery,
  isFoodCourt,
  isHolidaySurcharge,
  isPickupAndDelivery,
  isRenderDatetime,
  checkDineMobileOptional,
  disableNumberOfGuest,
  isSpecialTerms,
} from 'submodules/OrderCore';
import { Box } from '@material-ui/core';
import styled from 'styled-components';
import TextFieldLabel from './TextFieldLabel';
import SubmitButton from './SubmitButton';
import PaymentMethod from './PaymentMethod';
import { Information, IValidates, PaymentMethodType } from '../containers/AddInformationContainer';
import TermsAndPolicy from '../../../components/TermsAndPolicy/TermsAndPolicy';
import DateTimeComponent from './DateTimeComponent';
import PickupDeliveryComponent from './PickupDeliveryComponent';
import { EPickupDelivery, TPickupTimeType } from 'features/cart/types/CartTypes';
import SendCodeButton from './SendCodeButton';
import { useTranslation } from 'react-i18next';
import SpecialTerm from './SpecialTerm';
import HolidaySurcharge from './HolidaySurcharge';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { defaultCountry } from 'utils/constants';
import 'css-lib/PhoneNumberInput.css';
import { useStylesInputPhoneNumber } from 'features/step-menu/pages/AddInfomation/components/AddInformationStep';
import { theme } from 'theme';
import clsx from 'clsx';
import { checkValidatePhoneNumber } from 'utils/restaurantFeatures';
import { CountryCode } from 'libphonenumber-js';

export const TextRed = styled(Box)`
  color: red;
  font-size: 14px;
  margin-bottom: 10px;
`;
interface AddInformationProps {
  selected: string;
  loading: boolean;
  information: Information;
  onSubmit: () => void;
  onSendCode: () => void;
  onChangeCode: (event: React.ChangeEvent) => void;
  codeVerify: string;
  statusCodeVerify: boolean;
  onSelectMethod: (type: PaymentMethodType) => void;
  onChange: (event: React.ChangeEvent) => void;
  validates: IValidates;
  restaurant: IRestaurant;
  amountSurchargeFee: number | string;
  tableId: TTableId;
  pickupTimeType: TPickupTimeType;
  setPickupTimeType: (value: TPickupTimeType) => void;
  setPickupTime: (value: string) => void;
  setSelectedDate: (value: string) => void;
  pickupTime: string;
  selectedDate: string;
  pickupDeliveryType: EPickupDelivery;
  setPickupDeliveryType: (value: EPickupDelivery) => void;
  checkRenderPaymentMethod: () => boolean;
  isDineInTable: boolean;
  onChangePhoneNumber: (value: any) => void;
  countryCode: CountryCode | undefined;
  setCountryCode: (countryCode: CountryCode | undefined) => void;
}

function AddInformation({
  loading,
  onSubmit,
  codeVerify,
  statusCodeVerify,
  information,
  onChange,
  onSelectMethod,
  selected,
  validates,
  restaurant,
  amountSurchargeFee,
  tableId,
  pickupTimeType,
  setPickupTimeType,
  setPickupTime,
  setSelectedDate,
  pickupTime,
  selectedDate,
  pickupDeliveryType,
  setPickupDeliveryType,
  checkRenderPaymentMethod,
  onSendCode,
  onChangeCode,
  isDineInTable,
  onChangePhoneNumber,
  countryCode,
  setCountryCode,
}: AddInformationProps) {
  const { t } = useTranslation();
  const styles = useStylesInputPhoneNumber();

  return (
    <Fragment>
      <TextFieldLabel
        required
        onChange={onChange}
        value={information.name}
        label="Name "
        name="name"
        error={validates.name && !information.name}
      />
      {validates.name && !information.name && <TextRed>{t('Name is invalid')}</TextRed>}
      {(isDineInTable && !restaurant?.onlineSettings?.isDineInGuestNumberRequired) ||
      disableNumberOfGuest(tableId) ? (
        <></>
      ) : (
        <>
          <TextFieldLabel
            required={
              !checkDineMobileOptional(
                isDineInTable,
                restaurant.isDineMobileOptional,
                restaurant?.onlineSettings?.isDineInGuestNumberRequired,
              )
            }
            onChange={onChange}
            value={information.numberOfGuests}
            label={`Number of guests ${
              checkDineMobileOptional(
                isDineInTable,
                restaurant.isDineMobileOptional,
                restaurant?.onlineSettings?.isDineInGuestNumberRequired,
              )
                ? '( Optional )'
                : ''
            }`}
            name="numberOfGuests"
            type="number"
            error={
              !disableNumberOfGuest(tableId) &&
              !checkDineMobileOptional(
                isDineInTable,
                restaurant.isDineMobileOptional,
                restaurant?.onlineSettings?.isDineInGuestNumberRequired,
              ) &&
              validates.numberOfGuests &&
              !information.numberOfGuests
            }
          />
          {!disableNumberOfGuest(tableId) &&
            !checkDineMobileOptional(
              isDineInTable,
              restaurant.isDineMobileOptional,
              restaurant?.onlineSettings?.isDineInGuestNumberRequired,
            ) &&
            validates.numberOfGuests &&
            !information.numberOfGuests && <TextRed>{t('Number of guest is invalid')}</TextRed>}
        </>
      )}
      {isDineInTable && !restaurant?.onlineSettings?.isDineInMobilePhoneRequired ? (
        <></>
      ) : (
        <Box style={{ marginBottom: '20px' }}>
          <span
            style={{
              fontSize: '14px',
              lineHeight: '2.4rem',
              color: theme.palette.grey[700],
            }}
          >
            Mobile no.
            {checkDineMobileOptional(
              isDineInTable,
              restaurant.isDineMobileOptional,
              restaurant?.onlineSettings?.isDineInMobilePhoneRequired,
            )
              ? ' ( Optional )'
              : ' ( Required )'}
          </span>
          <PhoneInput
            addInternationalOption={false}
            defaultCountry={defaultCountry}
            value={information.mobile}
            onChange={onChangePhoneNumber}
            className={clsx(styles.inputPhone, styles.online)}
            onCountryChange={(e) => {
              setCountryCode(e);
            }}
          />
          {!checkDineMobileOptional(
            isDineInTable,
            restaurant.isDineMobileOptional,
            restaurant?.onlineSettings?.isDineInMobilePhoneRequired,
          ) &&
            validates.mobile &&
            checkValidatePhoneNumber(information, countryCode) && (
              <TextRed style={{ marginTop: '10px' }}>{t('invalidPhoneNumber')}</TextRed>
            )}
        </Box>
      )}
      {isFoodCourt(tableId) && (
        <TextRed
          style={{
            marginBottom: '20px',
          }}
        >
          ({t('Purpose for SMS once food ready')})
        </TextRed>
      )}
      {restaurant.smsVerify && (
        <Box>
          <SendCodeButton onClick={() => onSendCode()}></SendCodeButton>
          <TextFieldLabel
            required
            onChange={onChangeCode}
            value={codeVerify}
            label="Enter your code"
            name="code"
            type="number"
            error={statusCodeVerify}
          />
          {statusCodeVerify && <TextRed>{t('Code is invalid')}</TextRed>}
        </Box>
      )}
      <TextFieldLabel
        onChange={onChange}
        value={information.email}
        label="Email ( Optional )"
        name="email"
      />
      <TextFieldLabel
        required={isPickupAndDelivery(tableId) || isDelivery(tableId)}
        onChange={onChange}
        value={information.postcode}
        label={`Postcode ${
          isPickupAndDelivery(tableId) || isDelivery(tableId) ? '' : '( Optional )'
        }`}
        name="postcode"
        type="number"
        error={
          validates.postcode &&
          !information.postcode &&
          (isPickupAndDelivery(tableId) || isDelivery(tableId))
        }
      />
      {validates.postcode &&
        !information.postcode &&
        (isPickupAndDelivery(tableId) || isDelivery(tableId)) && (
          <TextRed>{t('Post code is invalid')}</TextRed>
        )}
      {isPickupAndDelivery(tableId) && (
        <PickupDeliveryComponent
          pickupDeliveryType={pickupDeliveryType}
          setPickupDeliveryType={setPickupDeliveryType}
        />
      )}
      {(isDelivery(pickupDeliveryType) || isDelivery(tableId)) && (
        <>
          <TextFieldLabel
            required
            onChange={onChange}
            value={information.address}
            label="Address"
            name="address"
            error={
              validates.address &&
              information.address === '' &&
              (isDelivery(pickupDeliveryType) || isDelivery(tableId))
            }
          />
          {validates.address &&
            information.address === '' &&
            (isDelivery(pickupDeliveryType) || isDelivery(tableId)) && (
              <TextRed>{t('Address is invalid')}</TextRed>
            )}
        </>
      )}
      {isRenderDatetime(tableId, isDineInTable) && (
        <DateTimeComponent
          pickupTimeType={pickupTimeType}
          setPickupTimeType={setPickupTimeType}
          setPickupTime={setPickupTime}
          setSelectedDate={setSelectedDate}
          validates={validates}
          pickupTime={pickupTime}
          selectedDate={selectedDate}
          tableId={tableId}
          restaurant={restaurant}
        />
      )}

      {isSpecialTerms(restaurant) && <SpecialTerm restaurant={restaurant} />}

      {checkRenderPaymentMethod() && (
        <PaymentMethod tableId={tableId} onClick={onSelectMethod} selected={selected} />
      )}
      {isHolidaySurcharge(restaurant) && (
        <HolidaySurcharge
          amountSurchargeFee={amountSurchargeFee}
          chargeName={restaurant.holidaySurcharge.name}
        />
      )}
      <TermsAndPolicy tableId={tableId} restaurant={restaurant} />
      <SubmitButton
        loading={loading}
        onSubmit={onSubmit}
        checkRenderPaymentMethod={checkRenderPaymentMethod}
        selected={selected}
      />
    </Fragment>
  );
}

export default AddInformation;
